export enum StatusRequest {
  REQUEST_CREATED = 1,
  REQUEST_SENDED = 2,
  REQUEST_CANCELED = 3,
}
